package top.wcpe.allincore.dsl.compiler.diag

import top.wcpe.allincore.dsl.compiler.source.SourcePosition

/**
 * M5-f：基于内存源码字符串的 SourceProvider 实现。
 *
 * 取错误行前后各 1 行作为上下文。
 */
class InMemorySourceProvider(
    private val filePath: String,
    private val source: String,
) : SourceProvider {
    // 懒解析行数组，避免反复切分
    private val lines: List<String> by lazy { source.lines() }

    override fun fetchSnippet(position: SourcePosition): SourceSnippet? {
        val line = position.line
        // 越界保护：未知位置或超出源文件范围时直接放弃
        if (line < 1 || line > lines.size) return null
        val startLine = maxOf(1, line - 1)
        val endLine = minOf(lines.size, line + 1)
        val contextLines = (startLine..endLine).map { lines[it - 1] }
        return SourceSnippet(
            filePath = filePath,
            lineNumber = line,
            columnNumber = position.column,
            contextLines = contextLines,
            errorLineIndex = line - startLine,
            markerStart = maxOf(0, position.column - 1),
            markerLength = position.range.length.coerceAtLeast(1),
        )
    }
}
